module.exports = __webpack_public_path__ + "static/media/undraw_react_y7wq.e56ab6de.svg";